import { countNightsLocal, formatIsoDateShort } from "@/lib/bookingDates";
import type { Booking, InvoiceLine } from "@/types/camping";

const PER_NIGHT_RULE_TYPES = new Set([
  "pitch_category_night",
  "adult_night",
  "child_night",
  "dog_night",
  "electricity_night",
]);

export function isPerNightInvoiceLine(line: InvoiceLine): boolean {
  if (!line.rule_type) return false;
  return PER_NIGHT_RULE_TYPES.has(line.rule_type);
}

export function formatInvoiceLinePeriod(line: InvoiceLine): string | null {
  if (!line.period_start || !line.period_end) return null;
  const nights = countNightsLocal(line.period_start, line.period_end);
  if (nights <= 0) return null;
  const lastNight = addDaysIso(line.period_start, nights - 1);
  if (nights === 1) {
    return formatIsoDateShort(line.period_start);
  }
  return `${formatIsoDateShort(line.period_start)} – ${formatIsoDateShort(lastNight)} (${nights} ${nights === 1 ? "Nacht" : "Nächte"})`;
}

function addDaysIso(isoDate: string, days: number): string {
  const parts = isoDate.split("-").map(Number);
  const y = parts[0] ?? 0;
  const m = parts[1] ?? 1;
  const d = parts[2] ?? 1;
  const date = new Date(y, m - 1, d + days);
  const ny = date.getFullYear();
  const nm = String(date.getMonth() + 1).padStart(2, "0");
  const nd = String(date.getDate()).padStart(2, "0");
  return `${ny}-${nm}-${nd}`;
}

export function defaultLinePeriod(
  line: InvoiceLine,
  booking: Booking | null | undefined,
): { periodStart: string; periodEnd: string } | null {
  if (!isPerNightInvoiceLine(line)) return null;
  const periodStart = line.period_start ?? booking?.arrival_date ?? null;
  const periodEnd = line.period_end ?? booking?.departure_date ?? null;
  if (!periodStart || !periodEnd) return null;
  return { periodStart, periodEnd };
}

export function validateLinePeriod(
  periodStart: string,
  periodEnd: string,
  booking: Booking | null | undefined,
): string | null {
  if (!periodStart || !periodEnd) {
    return "Bitte Start- und Enddatum angeben.";
  }
  if (periodEnd <= periodStart) {
    return "Enddatum muss nach dem Startdatum liegen.";
  }
  if (booking) {
    if (periodStart < booking.arrival_date || periodEnd > booking.departure_date) {
      return "Leistungszeitraum muss innerhalb des Aufenthalts liegen.";
    }
  }
  return null;
}
